/* tslint:disable */
/* eslint-disable */
/**
 * Selling Partner API for Product Type Definitions
 * The Selling Partner API for Product Type Definitions provides programmatic access to attribute and data requirements for product types in the Amazon catalog. Use this API to return the JSON Schema for a product type that you can then use with other Selling Partner APIs, such as the Selling Partner API for Listings Items, the Selling Partner API for Catalog Items, and the Selling Partner API for Feeds (for JSON-based listing feeds).  For more information, see the [Product Type Definitions API Use Case Guide](https://developer-docs.amazon.com/sp-api/docs/product-type-api-use-case-guide).
 *
 * The version of the OpenAPI document: 2020-09-01
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Link to retrieve the schema.
 */
export interface SchemaLinkLink {
    /**
     * URI resource for the link.
     */
    'resource': string;
    /**
     * HTTP method for the link operation.
     */
    'verb': SchemaLinkLinkVerbEnum;
}

export const SchemaLinkLinkVerbEnum = {
    Get: 'GET',
} as const;

export type SchemaLinkLinkVerbEnum = typeof SchemaLinkLinkVerbEnum[keyof typeof SchemaLinkLinkVerbEnum];


